import React, {
    useCallback, useEffect, useMemo, useState,
} from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form } from 'react-bootstrap';
import DatePicker from 'react-date-picker';

import Fetcher from '../common/communicate';
import '../css/game-release.css';

export default function GameReleaseBlock({
    data, gameId, onChange, isClosed, onClosedChange,
}) {
    const [regions, setRegions] = useState([]);
    const [platforms, setPlatforms] = useState([]);

    useEffect(() => {
        getRegions();
        getPlatforms();
    }, [gameId]);

    function getRegions() {
        Fetcher('regions/', 'GET', (data) => {
            setRegions(data.results);
        });
    }

    function getPlatforms() {
        Fetcher('tags/?type=platform&limit=100', 'GET', (data) => {
            setPlatforms(data.results);
        });
    }

    const itemsMap = useMemo(() => ({
        region: {
            options: regions,
            defaultValue: 5,
        },
        platform: {
            options: platforms,
            defaultValue: 5342,
        },
        date_text: {
            options: [
                {
                    id: 'day',
                    name: 'День',
                },
                {
                    id: 'month',
                    name: 'Месяц',
                },
                {
                    id: 'quarter',
                    name: 'Квартал',
                },
                {
                    id: 'year',
                    name: 'Год',
                },
                {
                    id: 'soon',
                    name: 'Скоро',
                },
            ],
            defaultValue: 'day',
        },
    }), [regions, platforms]);

    function handleChange(e) {
        const { value, dataset } = e.currentTarget;
        const { type, index } = dataset;
        // const options = type === 'region' ? regions : platforms;
        const newValue = itemsMap[type].options.find((el) => el.id === (type === 'date_text' ? value : +value));

        const clonedData = JSON.parse(JSON.stringify(data));

        clonedData[index] = {
            ...data[index],
            [type]: newValue.id,
        };

        onChange(clonedData);
    }

    function handleDateChange(date, index) {
        const clonedData = JSON.parse(JSON.stringify(data));
        const newDate = (date || new Date()).toLocaleString().split(',')[0].split('.').reverse().join('-');

        clonedData[index] = {
            ...data[index],
            date: newDate,
        };

        onChange(clonedData);
    }

    function handleItemAdd() {
        onChange([
            ...data,
            {
                date: new Date().toLocaleString().split(',')[0].split('.').reverse().join('-'),
                game_id: gameId,
                platform: itemsMap.platform.defaultValue,
                region: itemsMap.region.defaultValue,
                date_text: itemsMap.date_text.defaultValue,
            },
        ]);
    }

    function handleItemDelete(e) {
        const { index } = e.currentTarget.dataset;

        const clonedData = JSON.parse(JSON.stringify(data));
        clonedData.splice(index, 1);

        onChange(clonedData);
    }

    const formatDate = useCallback((date) => new Date(date), []);

    const getDateFormat = useCallback((format, date) => {
        const formatMap = {
            day: 'dd.MM.yyyy',
            month: `${new Date(date).toLocaleString('ru-Ru', { month: 'long' })} yyyy`,
            quarter: `Q${Math.floor((new Date(date).getMonth() + 3) / 3)} yyyy`,
            year: 'yyyy',
        };

        return formatMap[format] || formatMap.day;
    }, []);

    const renderSelect = useCallback((selectType, release, i) => {
        if (!regions.length || !platforms.length) {
            return null;
        }

        return (
            <Form.Group controlId={`${selectType}-select-${i}`}>
                <Form.Control
                    size="sm"
                    value={release[selectType] || itemsMap[selectType].defaultValue}
                    onChange={handleChange}
                    as="select"
                    placeholder="select"
                    data-type={selectType}
                    data-index={i}
                >
                    {itemsMap[selectType].options.map((item) => (
                        <option
                            key={item.id}
                            value={item.id}
                        >
                            {item.name}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
        );
    }, [regions.length, platforms.length, itemsMap, handleChange]);

    return (
        <div className={`game-releases ${isClosed ? 'game-releases_closed' : ''}`}>
            <Form.Label className="game-releases__label">
                <b> Релизы </b>
                <label className="game-releases__closed">
                    Проект закрыт
                    <input
                        className="game-releases__closed-input"
                        id="is_closed"
                        name="is_closed"
                        value={isClosed}
                        checked={isClosed}
                        onChange={onClosedChange}
                        type="checkbox"
                    />
                </label>
            </Form.Label>
            <div className="game-releases__list">
                {data.map((release, i) => (
                    <div key={`region-${i}`} className="game-releases__item">
                        {renderSelect('platform', release, i)}
                        {renderSelect('region', release, i)}
                        <DatePicker
                            id={`${release.id}-date-select`}
                            value={formatDate(release.date)}
                            onChange={(date) => handleDateChange(date, i)}
                            locale="ru-ru"
                            showLeadingZeros
                            format={getDateFormat(release.date_text, release.date)}
                        />
                        {renderSelect('date_text', release, i)}
                        <Button
                            id={`release-del-${i}`}
                            size="md"
                            data-index={i}
                            variant="outline-secondary"
                            onClick={handleItemDelete}
                        >
                            <FontAwesomeIcon icon="trash" />
                        </Button>
                    </div>
                ))}
            </div>
            <button
                className="game-releases__add"
                onClick={handleItemAdd}
                type="button"
            >
                +
            </button>
        </div>
    );
}
